// Company.js
import { db } from "./config";
import {
  doc,
  setDoc,
  collection,
  addDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

export async function registerCompany(
  companyName,
  industry,
  companySize,
  address,
  ownerId,
  timeZone,
  multiLocationEnabled = false, // ✅ NEW
) {
  const companyRef = doc(db, "companies", ownerId);

  // 1) create company doc (same as before)
  await setDoc(companyRef, {
    name: companyName,
    industry,

    // This is the actual team size selected during setup.
    size: companySize,

    address,
    ownerId,
    timeZone,
    createdAt: serverTimestamp(),

    stripeCustomerId: ownerId,

    multiLocationEnabled: !!multiLocationEnabled,
    primaryLocationId: null,

    // No plan has been selected yet
    subscription: null,

    plan: null,
    teamSize: null,
    employeeLimit: null,
    subscriptionStatus: "pending_selection",

    freePlanConfirmed: false,

    quickSetupProgress: {
      addedEmployee: false,
      setNotifications: false,
      createdSchedule: false,
      assignedTraining: false,
    },
  });

  // 2) create PRIMARY location document
  const locationsRef = collection(db, "companies", ownerId, "locations");
  const primaryLocationDoc = await addDoc(locationsRef, {
    name: "Main Office",
    address,
    isPrimary: true,
    active: true,
    createdAt: serverTimestamp(),
    createdBy: ownerId,
  });

  // 3) write primaryLocationId back to company doc
  await updateDoc(companyRef, {
    primaryLocationId: primaryLocationDoc.id,
    locationsCount: 1,
  });

  console.log(
    `Company ${companyName} registered with time zone: ${timeZone}, multiLocationEnabled=${multiLocationEnabled}`,
  );

  return { companyId: ownerId, primaryLocationId: primaryLocationDoc.id };
}
